export type ImageProps = {
  file_name: string
  image: string | null
  id?: number | null
  virus_scan_result?: 'clean' | 'yet' | 'infected' | null
}

export type UploadImagesProps = {
  attachment_images?: ImageProps[]
  identity_verification_images?: ImageProps[]
  insurance_card_images?: ImageProps[]
  certificate_images?: ImageProps[]
}

export type BillingStatusLabelsKeys = 'unbilled' | 'billed'

export const BillingStatusLabels: {
  [key in BillingStatusLabelsKeys]: '未請求' | '請求済'
} = {
  unbilled: '未請求',
  billed: '請求済',
}

export type ReservationStatusLabelsKeys =
  | 'before'
  | 'finish_no_billing'
  | 'finish'
  | 'billed'
  | 'canceled'

export const ReservationStatusLabels: {
  [key in ReservationStatusLabelsKeys]:
    | '開始前'
    | '通話完了'
    | '請求済'
    | '予約取消'
} = {
  before: '開始前',
  finish_no_billing: '通話完了',
  finish: '通話完了',
  billed: '請求済',
  canceled: '予約取消',
}

export type UpdatedByLabelsKeys = 'applicant' | 'institution'

export const UpdatedByLabels: {
  [key in UpdatedByLabelsKeys]: '申込者' | '医療機関'
} = {
  applicant: '申込者',
  institution: '医療機関',
}

export type CallMethodVideoAppNames = 'video_zoom' | 'video_teams'

export type CallMethodNames = 'phone' | CallMethodVideoAppNames
export type CallMethodLabels = '電話' | 'Zoom' | 'Microsoft Teams'

export type SettlementNameProps =
  | 'credit_card'
  | 'link'
  | 'bank_transfer'
  | 'cod'
  | 'next_visit'
  | 'no_charge'

export type ReservationFrameUnitMin = 30 | 15

export type DepartmentListItemProps = {
  id: number
  name: string
  supplementary_text: string
  is_open: boolean
  display_order: number
  reservation_frame_period_minutes: ReservationFrameUnitMin
}

export type PharmacyProps = {
  scuel_id: string
  name?: string
  address?: string
  business_day?: string
  close_day?: string
  phone_for_institution?: string
  fax?: string
  phone_for_patient?: string
  is_possible_delivery?: boolean
  description_for_patient?: string
  url?: string
}

export type LocationParams = { latitude?: number; longitude?: number }

export type PharmacySearchApiParams = {
  limit: number
  offset: number
  name?: string
  is_possible_delivery?: boolean
} & LocationParams

export type VerificationTypes = 'email' | 'sms'

// NOTE: 選択できる枠の単位
export type ReservationTimeUnit = 15 | 30

export type EligibilityVerificationUrlParams = {
  online_eligibility_verification_url: string
}
